<template>
      <b-col lg="12">
          <transition name="fade">
              <team-list
                      :results="results"
                      @edit="editTeam"
              />
          </transition>
          <span v-if="!loading && (!results || results.length < 1)">
                  {{ $t('team.no_teams') }}
          </span>
          <div
                  v-if="loading"
                  id="loader"
                  class="spinner"
          />
      </b-col>
</template>


<script>

    import FairApi from '../../modules/api'
    import {userHelper} from "../../mixins/UserMixin"
    import TeamList from "./TeamList"

    export default {
        name: 'teams',
        mixins: [userHelper],
        components: {TeamList},
        data: function () {
            return {
                results: [],
                loading: false,
            }
        },
        created: function () {
            this.fetchTeams()
        },

        methods: {
            fetchTeams: function () {
                this.loading = true
                FairApi.get(FairApi.team(), this.success, this.failed)
            },

            success: function (response) {
                this.results = response
                this.loading = false
            },

            failed: function () {
                this.loading = false
                this.showAlert(this.$t('common.fetch_failed'))
            },

            editTeam: function (team) {
                this.$emit('editTeam', team)
            },

            showAlert: function (msg) {
                this.$emit('alert', msg)
            }
        }
    }
</script>
